import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {IMyDateModel,IMyDefaultMonth,IMyDpOptions,IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService} from 'ngx-bootstrap';
// date picker
import * as cloneDeep from 'lodash/cloneDeep';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {TreeviewConfig,TreeviewItem} from "ngx-treeview";
import {BehaviorSubject,Observable,forkJoin} from 'rxjs';
import {Principal,StateStorageService} from 'src/app/core';
import {CargoGroupMySuffixService} from 'src/app/entities/cargo-group-my-suffix';
import {CountryMySuffixService} from 'src/app/entities/country-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {RuleDeductableRateMySuffix} from 'src/app/shared/model//rule-deductable-rate-my-suffix.model';
import {ICargoGroupMySuffix} from 'src/app/shared/model/cargo-group-my-suffix.model';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {ILoadingSubTypeDto} from 'src/app/shared/model/loading-subtype.model';
import {ILoadingTypeDto,LoadingTypeMySuffix} from 'src/app/shared/model/loading-type-my-suffix.model';
import {OtsDataSharingModal} from 'src/app/shared/model/ots-data-sharing.model';
import {RuleExtensionRateMySuffix} from 'src/app/shared/model/rule-extension-rate-my-suffix.model';
import {ActiveStatus,IRuleMySuffix} from 'src/app/shared/model/rule-my-suffix.model';
import {DeductibleType,IScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {currenyMaskService} from '../../shared/currencyMask.service';
import {ISubRuleMySuffix} from './../../shared/model/subrule-my-suffix.model';
import {LoadingTypeMySuffixService} from './../loading-type-my-suffix/loading-type-my-suffix.service';
import {ScopeMySuffixService} from './../scope-my-suffix/scope-my-suffix.service';
import {RuleMySuffixService} from './rule-my-suffix.service';
import { NgModel } from '@angular/forms';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { TdisConstants } from 'src/app/shared/constants/tdis-constants';

declare let $: any;

export const enum RuleType {
    LOCAL = 'LOCAL',
    INTERNATIONAL = 'INTERNATIONAL'
}

@Component({
    selector: 'jhi-rule-my-suffix-update',
    templateUrl: './rule-my-suffix-update.component.html'
})
export class RuleMySuffixUpdateComponent implements OnInit, OnDestroy {

    readonly RoleUtil = RoleUtil;
    readonly TdisConstants = TdisConstants;

    private _rule: IRuleMySuffix;
    isSaving: boolean;

    cargogroups: ICargoGroupMySuffix[];

    countries: ICountryMySuffix[];

    scopeData: IScopeMySuffix;
    extensionsList = [];
    // LoadingTypeList = []
    loadingTypesList: any[] = [];
    copyloadingTypes: ILoadingTypeDto[];
    loadingSubTypeDto: ILoadingSubTypeDto[];
    ruleId: number = 0;
    loadingTypeFlag: boolean;
    numberPattern = '^[0-9]+(.[0-9]{0,9})?$';

    loadingSubTypesDTOList: any;
    copyloadingSubTypesDTOList: any;
    deductiblesList = [
        {
            id: null,
            decuctableName: null,
            decuctableDescription: null,
            flatPercentage: null,
            flatValue: null,
            minimumValue: null,
            maximumValue: null,
            percentage: null,
            activeStatus: null,
            ruleId: null
        }
    ];
    dropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };
    loadingTypeDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen: false,
    };
    cargogroupsDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen:false
    };

    isPackingTypeDTO = false;
    packingTypeValue = [];

    // date picker

    bsConfig: Partial<BsDatepickerConfig>;
    dob = new Date();
    minExpiryDate: Date;
    isOpenID = false;
    isOpenED = false;

    inceptionMinDate: Date;
    inceptionMaxDate: Date;
    expiryMinDate: Date;
    expiryMaxDate: Date;

    // Currency
    amountOptions: any;
    rateOptions: any;

    isRuleUsedInCertificate=false;

    inceptionDate: any;
    expiryDate: any;


    resetDateModel = {
        year: 0,
        month: 0,
        day: 0
    }
    inceptionPickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel,
        disableSince: this.resetDateModel,

    };

    expiryDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy'
    };

    inceptionDateFormate: { year: number; month: number; day: number; };
    expiryDateFormate: { year: number; month: number; day: number; };
    storagePolicyDateOption: { dateFormat: string; disableUntil: any; disableSince: any; };
    public defaultMonth: IMyDefaultMonth = {
        defMonth: new Date().getMonth() + 1 + '/' + new Date().getFullYear()
    };

    // effective date
    date: Date = new Date();
    pastDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.pastDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    isScopeExpired: boolean = false;
    isRuleExpired: boolean = false;
    isNewRule: boolean = false;
    addExtensionButtonEnable: any;
    deductibleType: DeductibleType;
    addLoadingTypeButtonEnable: any;

    ruletypeList = [];

    ruleTypeDropdownSettings = {
        singleSelection: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: false,
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen:false
    };

    ruleTypeValue = [];

    isRuleTypeInternational=true;

    certificateRequestId : number;
    isOneTimeScope: boolean = false;
    certificateScope : number;
    isCreatedFromPolicy: boolean=false;
    isFromAutomateOts: boolean=false;
    scopeId;
    subRuleData: ISubRuleMySuffix[]=[];
    previousScopeRulesData=[];
    isExtensionDeductableCollapsed = false;
    isloadingTypeListCollapsed = false;
    loadingType:any;
    otsSummaryPageUrl: string = '';

    dataSharingModal:OtsDataSharingModal = new OtsDataSharingModal();

    fromCountryData:TreeviewItem[] = [];
    toCountryData:TreeviewItem[] = [];
    countriesMap = new Map<number, any>();
    selectedFromCountry: any[] = [80];
    selectedToCountry: any[] = [80];
    fromCountriesId: any = [];
    toCountriesId: any = [];
    config = TreeviewConfig.create({
        hasAllCheckBox: true,
        hasFilter: true,
        hasCollapseExpand: true,
        decoupleChildFromParent: false,
        maxHeight: 400,
    });
    
    isChecked: boolean = false;

    countriesData: TreeviewItem[];

    isApiDone$ = new BehaviorSubject(true);
    typeOfAction:string;

    constructor(
        private jhiAlertService: JhiAlertService,
        private ruleService: RuleMySuffixService,
        private cargoGroupService: CargoGroupMySuffixService,
        private countryService: CountryMySuffixService,
        private activatedRoute: ActivatedRoute,
        private scopeMySuffixService: ScopeMySuffixService,
        private loadingTypeMySuffixService: LoadingTypeMySuffixService,
        private currencyMask: currenyMaskService,
        private principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private router: Router,
        private stateStorageService:StateStorageService
    ) { 
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });

       if(localStorage.getItem('RULE_CLONE')){
          this.typeOfAction = localStorage.getItem('RULE_CLONE')
       }
    
    }
    ngOnDestroy(): void {
      localStorage.removeItem('RULE_CLONE')
    }

    otsKeyword: string = '';
    isOts: boolean = false;
    randomOtsId=null;
    isRuleIdPresent: boolean = false;

    ngOnInit() {
        
        this.ruletypeList = [
            {
                id: 'LOCAL',
                name: 'Local'
            },
            {
                id: 'INTERNATIONAL',
                name: 'International'
            }
        ];

        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        window.scroll(0, 0);
        this.amountOptions = this.currencyMask.amountPrecisionOptions;
        this.rateOptions = this.currencyMask.ratePrecisionOptions;

        this.isSaving = false;
        this.scopeId = this.activatedRoute.snapshot.params['scopeId'];
        this.isFromAutomateOts = this.activatedRoute.snapshot.params['ots']!=undefined;
        
        this.isApiDone$.next(!this.isFromAutomateOts);


        const CURRENT_URL: string = this.router.url;
        // let current_url_split: string[] = CURRENT_URL.split('/');
        this.isOts = CURRENT_URL.includes('ots');
        const isSummaryDetailsUrl: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);

        if(this.isFromAutomateOts || (this.isOts && isSummaryDetailsUrl)) {
            this.otsSummaryPageUrl = JSON.parse(isSummaryDetailsUrl);
            this.otsKeyword = 'ots';
        }
        
        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];
        
        if(this.randomOtsId!=null && this.stateStorageService.contains(this.randomOtsId)) {
            this.otsSummaryPageUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.isFromAutomateOts=true;
            this.otsKeyword = 'ots';
        }


        this.certificateRequestId=this.activatedRoute.snapshot.params['crId'];
        this.checkAccountingPermission();
        this.checkPremiumCalculationPermission();


        this.dataSharingModal = this.setDataInModal(this.scopeId,this.isOts, this.isFromAutomateOts,this.certificateRequestId)

        if(this.scopeId!=null&&this.scopeId!=0) {
            let forRule;
            if(this.certificateRequestId) {
                forRule = this.scopeMySuffixService.findOneTimeScopedataForRule(this.scopeId, this.certificateRequestId)
            } else {
                forRule = this.scopeMySuffixService.findScopedataForRule(this.scopeId)
            }
            forRule.subscribe(data => {
                console.log(data.body)
                this.scopeData = data.body;

                if(this.dataSharingModal && this.dataSharingModal.isOts){
                    this.dataSharingModal.otsScopeId=this.scopeData.id;
                    if(this.scopeData.rules.length>0) {
                        this.dataSharingModal.oldRuleId = this.scopeData.rules[0].id;
                    }
                    // this.dataSharingModal.otsSubRuleIds = this.scopeData.rules[0].subRuleId;
                }

                this.deductibleType = this.scopeData.deductibleType;
                this.extensionsList = data.body.extensions;
                this.rule.deductableRates.forEach(item=>{
                    if (this.scopeData.deductibleType == 'FLAT_PERCENTAGE') {
                        item.maximumValue = null;
                        item.percentage = null;
                        item.minimumValue = null;
                        item.flatValue = null;
                    } else if (this.scopeData.deductibleType == 'FLAT_VALUE') {
                        item.maximumValue = null;
                        item.percentage = null;
                        item.minimumValue = null;
                    } else {
    
                    }
                })
                console.log("this.rule.deductableRates",this.rule.deductableRates);
                // if (this.rule.id == null) {
                if (CommonUtils.isNil(this.rule.id)) {
                    const inception = this.principal.dateFormateServerToClient(this.scopeData.streffectiveDate);
                    const expiry = this.principal.dateFormateServerToClient(this.scopeData.strexpiryDate);
                    this.inceptionDate = { date: inception }
                    this.expiryDate = { date: expiry }
                    let defMonth = this.scopeData.streffectiveDate.split("-");
                    this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[0] };
                    this.isNewRule=true;
                    if(this.isFromAutomateOts) {
                        this.scopeData.rules.forEach(r => {
                            // this.scopeData.scopeType='ONE_TIME';
                            if(r.type=='LOCAL') {
                                this.ruleTypeValue=[this.ruletypeList[0]];
                                this.rule.type=r.type;
                                this.isRuleTypeInternational=false;
                            } else if(r.type=='INTERNATIONAL') {
                                this.ruleTypeValue=[this.ruletypeList[1]];
                                this.rule.type=r.type;
                                this.isRuleTypeInternational=true;
                            }
                            this.rule.meansOfConveyance=r.meansOfConveyance;
                            this.rule.cargoLists=r.cargoLists
                            this.getLoadingTypeList()
                            this.rule.loadingType=r.loadingType
                            // this.rule.loadingType.loadingSubTypeDto.forEach(loading=>{
                            //     this.rule.loadingType.loadingSubTypeDto = loading.packingTypes
                            // })
                            this.isOneTimeScope=true;
                            this.rule.fromCountryLists=r.fromCountryLists
                            this.rule.toCountryLists=r.toCountryLists;
                            this.rule.ruleIdForOts = r.id;
                        })
                    }
                   
                } else {
                    //if extensions are removed from scopes then removing from rules
                    if (this.extensionsList.length == 0) {
                        this.rule.extensions = [];

                    } else {
                        for (let index = 0; index < this.rule.extensions.length; index++) {
                            const extension = this.rule.extensions[index];
                            let resultArray = this.extensionsList.filter(data => data.id == extension.extensionsId);

                            if (resultArray.length == 0) {
                                this.removeExtensions(index);
                            }

                        }
                    }

                    if (this.rule.extensions.length === 0) {
                        let extenstion = new RuleExtensionRateMySuffix();
                        this.rule.extensions.push(extenstion);
                    }

                }

                // if (this.rule && this.rule.id && this.rule.loadingType.length > 0 ) {
                //     this.rule.loadingType.forEach((res, index) => {
                //         this.rule.loadingType[index].isSubtypeShow = true;
                //         this.rule.loadingType[index].loadingTypeAr = [];
                //         if (res) {
                //             this.rule.loadingType[index].loadingTypeAr.push(this.rule.loadingType[index]);
                //         }
                //     })
                // }


                this.inceptionPickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.principal.dateFormateServerToClientMin(this.scopeData.streffectiveDate),
                    disableSince: this.principal.dateFormateServerToClientMax(this.scopeData.strexpiryDate),
                }

                this.expiryDatePickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.principal.dateFormateServerToClientMin(this.scopeData.streffectiveDate),
                    disableSince: this.principal.dateFormateServerToClientMax(this.scopeData.strexpiryDate)
                }



                this.isApiDone$.next(true);
            });
       

        }
        else{
            this.scopeMySuffixService.findScopedataForRule(this.scopeId).subscribe(data => {
                console.log(data.body)
                this.scopeData = data.body;
                this.deductibleType = this.scopeData.deductibleType;
                this.extensionsList = data.body.extensions;
                this.rule.deductableRates.forEach(item=>{
                    if (this.scopeData.deductibleType == 'FLAT_PERCENTAGE') {
                        item.maximumValue = null;
                        item.percentage = null;
                        item.minimumValue = null;
                        item.flatValue = null;
                    } else if (this.scopeData.deductibleType == 'FLAT_VALUE') {
                        item.maximumValue = null;
                        item.percentage = null;
                        item.minimumValue = null;
                    } else {
        
                    }
                })
                console.log("this.rule.deductableRates",this.rule.deductableRates);
                if (this.rule.id == null) {
                    const inception = this.principal.dateFormateServerToClient(this.scopeData.streffectiveDate);
                    const expiry = this.principal.dateFormateServerToClient(this.scopeData.strexpiryDate);
                    this.inceptionDate = { date: inception }
                    this.expiryDate = { date: expiry }
                    let defMonth = this.scopeData.streffectiveDate.split("-");
                    this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[0] };
                    this.isNewRule = true;                       
                } else {
                     //if extensions are removed from scopes then removing from rules
                    if (this.extensionsList.length == 0) {
                        this.rule.extensions = [];
    
                    } else {
                        for (let index = 0; index < this.rule.extensions.length; index++) {
                            const extension = this.rule.extensions[index];
                            let resultArray = this.extensionsList.filter(data => data.id == extension.extensionsId);
    
                            if (resultArray.length == 0) {
                                this.removeExtensions(index);
                            }
    
                        }
                    }
    
                    if (this.rule.extensions.length === 0) {
                        let extenstion = new RuleExtensionRateMySuffix();
                        this.rule.extensions.push(extenstion);
                    }
    
                }
    
                this.inceptionPickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.principal.dateFormateServerToClientMin(this.scopeData.streffectiveDate),
                    disableSince: this.principal.dateFormateServerToClientMax(this.scopeData.strexpiryDate),
                }
    
                this.expiryDatePickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.principal.dateFormateServerToClientMin(this.scopeData.streffectiveDate),
                    disableSince: this.principal.dateFormateServerToClientMax(this.scopeData.strexpiryDate)
                }
            });
        }

        this.bsConfig = Object.assign(
            {},
            {
                containerClass: 'custom-datepicker-theme',
                showWeekNumbers: false,
                dateInputFormat: 'DD/MM/YYYY'
            }
        );
        
        this.activatedRoute.data.subscribe(({ rule }) => {
            this.rule = rule;
            this.ruleId = rule.id;
            if(CommonUtils.isNotNil(this.ruleId)) {
                this.isRuleIdPresent = true;
            }
            

            if (rule.id) {

                this.getLoadingTypeList();
                if (rule.extensions.length === 0) {
                    let extenstion = new RuleExtensionRateMySuffix();
                    this.rule.extensions.push(extenstion);
                }
                if (rule.deductableRates.length === 0) {
                    let deductableRate = new RuleDeductableRateMySuffix();
                    this.rule.deductableRates.push(deductableRate);
                }

                if (this.rule.type == 'LOCAL') {
                    this.ruleTypeValue.push(this.ruletypeList[0]);
                    this.isRuleTypeInternational = false;
                } else if (this.rule.type == 'INTERNATIONAL') {
                    this.ruleTypeValue.push(this.ruletypeList[1]);
                    this.isRuleTypeInternational = true;
                }

                this.isRuleUsedInCertificate = this.rule.isRuleUsedInCertificate;

            } else {
                this.rule.warStrikePremiumRate = 0;
            }
            this.enableDisableButton();
        });
        this.cargoGroupService.queryAll().subscribe(
            (res: HttpResponse<ICargoGroupMySuffix[]>) => {
                this.cargogroups = res.body;
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
        // this.countryService.query().subscribe(
        //     (res: HttpResponse<ICountryMySuffix[]>) => {
        //         this.countries = res.body;
        //         this.rule.toCountryLists = this.getCountries(this.rule.toCountryListsId);
        //         this.rule.fromCountryLists = this.getCountries(this.rule.fromCountryListsId);
        //     },
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );

        this.isApiDone$.subscribe(done=>{
            if(done){
                let ruleId = null;
                if(this.isFromAutomateOts && this._rule.ruleIdForOts!=null){
                    ruleId = this._rule.ruleIdForOts
                }else if(this.ruleId!=null){
                    ruleId = this.ruleId;
                }
                if(ruleId==null){ // for new rule
                    // const a$: any = this.countryService.query();
                    const b$ = this.ruleService.getCountriesByContinents();
                    if (b$) {
                        localStorage.setItem('countriesByContinents', JSON.stringify(b$));                                                
                    }
                    forkJoin([b$]).subscribe((res: any) => {
                         // ################################################################
                        // all countries data
                        // this.countries = res[0].body;
                        // this.rule.toCountryLists = this.getCountries(this.rule.toCountryListsId);
                        // this.rule.fromCountryLists = this.getCountries(this.rule.fromCountryListsId);
        
                        // ################################################################
        
                        // countries with continents
                        let countriesWithContinents: any = res[0].body;
                        let data:TreeviewItem[] ;
                        if(countriesWithContinents) {
                            data = this.mapToTreeViewItem(countriesWithContinents);
                            this.fromCountryData = data;
                            this.toCountryData = cloneDeep(data);
                        }
                    });
                }else{  // for edit and ots
                    // const a$: any = this.countryService.query();
                    const b$ = this.ruleService.getCountriesByContinentsByRuleId(ruleId,'from')
                    const c$ = this.ruleService.getCountriesByContinentsByRuleId(ruleId,'to')
            
                    
                    forkJoin([b$,c$]).subscribe((res: any) => {
                        // all countries data
                        this.countries = res[0].body;
                        let fromCountriesWithContinents: any = res[0].body;
                        let toCountriesWithContinents: any = res[1].body;
                        // this.rule.toCountryLists = this.getCountries(this.rule.toCountryListsId);
                        // this.rule.fromCountryLists = this.getCountries(this.rule.fromCountryListsId);
        
                        // ################################################################
        
                        // countries with continents
                        if(fromCountriesWithContinents) {
                            let fromData:TreeviewItem[] = this.mapToTreeViewItem(fromCountriesWithContinents);
                            this.fromCountryData = fromData;
                            this.fromCountryData.forEach(item => this.fromCountryId.push(item.value));
                        }
        
                        if(toCountriesWithContinents) {
                            let toData:TreeviewItem[]  = this.mapToTreeViewItem(toCountriesWithContinents);
                            this.toCountryData = toData;
                            this.toCountryData.forEach(item => this.toCountryId.push(item.value));
                        }
                    });
                }
        
            }
        })

       
        this.fromEffeciveDate = { date: this.dateModel };
    }

    fromCountryId: any[] = [];
    toCountryId: any[] = [];

    getCountries(id: number[]): ICountryMySuffix[] {
        let country = [];
        this.countries.forEach(cntry => {
            if(id){
                id.forEach(i => {
                    if (cntry.id == i) {
                        country.push(cntry);
                    }
                });
            }
            
        });
        return country;
    }
    getCountry(id: number, ids: number[]): any {
        ids.forEach(data => {
            if (data == id) {
                return data;
            }
        });
    }

    /* addExtensions */
    addExtensions() {
        let obj = {
            id: null,
            rate: null,
            activeStatus: 'ACTIVE',
            extensionsId: null
        };
        let extenstion = new RuleExtensionRateMySuffix();
        this.rule.extensions.push(extenstion);
        this.enableDisableButton()
    }
    removeExtensions(index: any) {
        this.rule.extensions.splice(index, 1);
        this.enableDisableButton()
    }
    /* addDeductibles */
    addDeductibles() {
        const deductable = new RuleDeductableRateMySuffix();
        deductable.deductibleType = this.deductibleType;
        this.rule.deductableRates.push(deductable);
    }
    removeDeductibles(index: any) {
        this.rule.deductableRates.splice(index, 1);
    }

    previousState() {
        // if rule is not summitted then back to scope view or road rule summited go back to scope view
        // if addSubrulebutton not clicked go back to scope view

        // if isFromAutomateOts but no rule id , then scope ots view page with back to summary buttton

        if(!this.dataSharingModal.isOts && !this.isFromAutomateOts) { // for normal
            this.router.navigateByUrl('scope-my-suffix/'+this.scopeId+'/view');
        } else { // for automated ots
            this.router.navigate(['scope-my-suffix/'+this.scopeId+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
        }

        return;
        // if((this.isFromAutomateOts && this.scopeId) || (this.otsKeyword && this.otsSummaryPageUrl)) {
        //     this.router.navigateByUrl('scope-my-suffix/'+this.scopeId+'/ots/view');
        // } else if(!(this.isFromAutomateOts && this.scopeId) || !(this.otsKeyword && this.otsSummaryPageUrl)) {
        //     this.router.navigateByUrl('scope-my-suffix/'+this.scopeId+'/view');
        // } else if(this.rule.id && this.scopeData.id && this.isAddSubRuleClicked) {
        //     this.router.navigate(['/rule-my-suffix', this.rule.id, this.scopeData.id, 'view' ])
        // }
        // else {
        //     window.history.back();
        // }
    }

    dateFormateChange(date) {
        let initDate = new Date(date);
        let day = ('0' + initDate.getDate()).slice(-2);

        let month = ('0' + (initDate.getMonth() + 1)).slice(-2);

        let year = initDate.getFullYear();

        return year + '-' + month + '-' + day;
    }

    save() {
        let fromEffectiveDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.rule.fromEffectiveDate = fromEffectiveDate;
        this.rule.loadingSubTypes = null;
        if (this.hasDuplicateObjects(this.rule.loadingType)) {
            this.jhiAlertService.error('Please remove duplicate Loading Type & Packing Type');
            return;
        }
        //subType selected or not
        if(this.scopeData.lineOfBusiness === TdisConstants.LineOfBusiness.MARINE) {
            let increment = this.checkSubTypeSelectedOrNot();
            if (increment == 0) {
                this.onError('packing type required');
                return;
            }
        }

        // this.openConfirmationModalForFutureRecordDeletion();
        this.saveOrUpdate();
    }

    saveOrUpdate() {
        this.isSaving = true;
        // for (let i = 0; i < this.rule.loadingType.length; i++){
        //     let lType = this.rule.loadingType[i];
        //     if (lType.loadingTypeAr.length > 0) {
        //         this.rule.loadingType[i].loadingTypeAr = []
        //     }
        // };
        if(this.typeOfAction === 'CLONE'){
           delete this.rule.id
        }

        if(this.fromCountriesId.length === 0) {
            this.onError('From country is required');
            return;
        }

        if(this.isRuleTypeInternational && this.toCountriesId.length === 0) {
            this.onError('To country is required');
            return;
        }

        for (let _loadingType of this.rule.loadingType){  
            if (_loadingType.loadingTypeAr.length > 0) {
                _loadingType.loadingTypeAr = [];
            }
        }
        
        console.log(this.rule.loadingType, "loading type on save");
        
        if (!this.rule.warStrikePremiumRate) {
            this.rule.warStrikePremiumRate = 0;
        }

        let incDate = this.principal.dateFormateClientToServer(this.inceptionDate.date);
        let expDate = this.principal.dateFormateClientToServer(this.expiryDate.date);
        // final update
        this.rule.strInceptionDate = incDate;
        this.rule.strExpiryDate = expDate;


        if(this.fromCountriesId.length > 0) {
            this.rule.fromCountryLists = [];
            this.fromCountriesId.filter(c=>this.countriesMap.has(c)).forEach(c=>{
                const coun:TreeviewItem=this.countriesMap.get(c);
                this.rule.fromCountryLists.push({id:coun.value,name:coun.text})
            });
        } else {
            this.rule.fromCountryLists = [];
        }


        if(this.toCountriesId.length > 0) {
            this.rule.toCountryLists = [];
            this.toCountriesId.filter(c=>this.countriesMap.has(c)).forEach(c=>{
                const coun:TreeviewItem=this.countriesMap.get(c);
                this.rule.toCountryLists.push({id:coun.value,name:coun.text})
            });
        } else {
            this.rule.toCountryLists = [];
        }

        console.log(this.rule);

        if (incDate <= expDate) {
            this.rule.inceptionDate = null;
            this.rule.expiryDate = null;    
            this.rule.scopeRule = this.scopeData ? this.scopeData : null;
            if (CommonUtils.isNotNil(this.rule.id)) {
                this.subscribeToSaveResponse(this.ruleService.update(this.rule));
            } else {
                if(this.isFromAutomateOts) {
                    this.previousScopeRulesData=this.scopeData.rules;
                    if(this.previousScopeRulesData.length>0) {
                        this.dataSharingModal.oldRuleId = this.previousScopeRulesData[0].id;
                    }
                    this.scopeData.rules = [];
                }
                this.subscribeToSaveResponse(this.ruleService.create(this.rule));
            }
        } else {
            this.onError('Expiry Date is Less Than InceptionDate');
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IRuleMySuffix>>) {
        result.subscribe((res: HttpResponse<IRuleMySuffix>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError());
    }

    private onSaveSuccess(res) {
        this.isSaving=false;
        this.deleteExistedFutureRecordDetails();

        if(this.dataSharingModal.isOts && this.isFromAutomateOts) { // only when we are coming from ots
            // on cancel go to ots scope view page + bts button
            // on noraml submit go to ots rule view page + bts button
            // on addsubrule submit -
            // if sub rule present in previous rule, go to new add sub rule page with data of previous subrule
            // else normal ots new sub rule page

            if(!this.isAddSubRuleClicked) {
                this.router.navigate(['rule-my-suffix/'+res.body.id+'/'+this.scopeId+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
            } else {

                if(this.previousScopeRulesData.length>0) {
                    // get subrule data from previous internation rule
                    this.ruleService.getSubRuleDataFromCertificateRequest(this.previousScopeRulesData[ 0 ].id,this.certificateRequestId).subscribe(sub => {
                        if(sub && sub.body) {
                            this.subRuleData=sub.body;
        
                            this.dataSharingModal.otsRuleId=res.body.id;
        
                            if(this.subRuleData&&this.subRuleData.length>1) {
                                let subRules=[];
                                if(this.subRuleData[ 0 ].carriage=='POST') {
                                    subRules[ 0 ]=this.subRuleData[ 1 ];
                                    subRules[ 1 ]=this.subRuleData[ 0 ];
                                } else {
                                    subRules=this.subRuleData;
                                }
                                this.dataSharingModal.oldSubRules=subRules;
                            } else {
                                this.dataSharingModal.oldSubRules=this.subRuleData;
                            }
        
                            this.dataSharingModal.policyScopeType=this.scopeData.policyMarketType;
        
                            if(this.subRuleData==null || this.subRuleData.length==0) {
                                // show warning message in sub rule in case
                                this.router.navigate( ["/sub-rule-my-suffix/new/"+res.body.id+"/"+this.scopeData.policyMarketType+"/ots/"+this.scopeId ],{queryParams:{ranOtsId:this.randomOtsId}});
                            }
                            else  {
                                this.router.navigate([ 'sub-rule-my-suffix/new/ots/',this.dataSharingModal.oldSubRules[ 0 ].id,'add' ],{queryParams: {sharedData: JSON.stringify(this.dataSharingModal),ranOtsId:this.randomOtsId}})
                            }
                            
                        } else { // previous sub rule data not found 
                            // this.router.navigate([ 'rule-my-suffix/'+res.body.id+'/'+this.scopeId+'/ots/view' ],{queryParams: {ranOtsId: this.randomOtsId}});
                            this.router.navigate( ["/sub-rule-my-suffix/new/"+res.body.id+"/"+this.scopeData.policyMarketType+"/ots/"+this.scopeId ],{queryParams:{ranOtsId:this.randomOtsId}});
                            // this.router.navigate([ "/sub-rule-my-suffix/new/"+res.body.id+"/"+this.scopeData.policyMarketType+"/ots/"+this.scopeId ]);   
                        }
                    })
                } else {
                    // if subrule button cliecked button previous rule is not having any sub rule , go to new ots add sub rule
                    this.router.navigate( ["/sub-rule-my-suffix/new/"+res.body.id+"/"+this.scopeData.policyMarketType+"/ots/"+this.scopeId ],{queryParams:{ranOtsId:this.randomOtsId}});
                    // this.router.navigate([ "/sub-rule-my-suffix/new/"+res.body.id+"/"+this.scopeData.policyMarketType+"/ots/"+this.scopeId ]);
                }
            }
        } else { // for normal flow
            
            // on cancel go to scope view page
            // on noraml submit go to rule view page
            // on addsubrule submit , go to new add sub rule page

            if(!this.isAddSubRuleClicked) {
                this.router.navigate([ '/rule-my-suffix',res.body.id,this.scopeData.id,'view' ]);
            } else {
                this.router.navigate([ '/sub-rule-my-suffix/new/'+res.body.id+'/'+this.scopeData.id+'/'+this.scopeData.policyMarketType ]);
            }
        }

        return;
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackCargoGroupById(index: number, item: ICargoGroupMySuffix) {
        return item.id;
    }

    trackCountryById(index: number, item: ICountryMySuffix) {
        return item.id;
    }

    trackLoadingTypeById(index: number, item: ILoadingTypeDto) {
        return item.id;
    }

    getSelected(selectedVals: any, option: any) {
        if (selectedVals) {
            // this.onLoadingTypeChange(selectedVals);
            if (option.id === selectedVals.id) {
                return selectedVals;
            }
        }
        return option;
    }
    get rule() {
        return this._rule;
    }

    set rule(rule: IRuleMySuffix) {
        this._rule = rule;

        let inception = this.principal.dateFormateServerToClient(rule.strInceptionDate);
        let expiry = this.principal.dateFormateServerToClient(rule.strExpiryDate);
        // this.setDateFormat(inception, expiry);

        this.inceptionDate = { date: inception };
        this.expiryDate = { date: expiry };

        if (rule.id) {

            let defMonth = rule.strInceptionDate.split("-");
            this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[0] };
            this.inceptionDateFormate = this.principal.dateFormateServerToClientMin(rule.inceptionDate);
            this.expiryDateFormate = this.principal.dateFormateServerToClientMax(rule.expiryDate);

            this.expiryDatePickerOptions = {
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.principal.dateFormateServerToClientMin(rule.strInceptionDate)
            }

            this.effectivepDatePickerOptions = {
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.pastDateModel,
                disableSince: this.expiryDateFormate,
            };

            if (rule.activeStatus === ActiveStatus.IN_ACTIVE) {
                this.isNewRule = true;
            }
        }
    }

    setDateFormat(inception, expiry) {
        this.inceptionDate = new Date(inception);
        this.expiryDate = new Date(expiry);
    }

    checkSubTypeSelectedOrNot() {
        let increment
        for(let i=0;i<this.rule.loadingType.length;i++) {
            increment=0;
            for(let index=0;index<this.rule.loadingType[ i ].loadingSubTypeDto.length;index++) {
                const packingTypes=this.rule.loadingType[ i ].loadingSubTypeDto[ index ].packingTypes;
                for(let j_index=0;j_index<packingTypes.length;j_index++) {
                    const element=packingTypes[ j_index ];
                    if(element.ischecked==true) {
                        increment++;
                    }
                }
            }
            if(increment==0) return increment;
        }
        return increment;
    }

    extensionValidtion(data: any, index: number) {
        if (this.rule.extensions.includes(data)) {
        }
        this.rule.extensions.forEach((ext, i) => {
            if (ext.extensionsId == data.extensionsId && index != 0 && data.extensionsId) {
                if (i != index) {
                    this.onError('Extension already selected');
                    this.removeExtensions(index);
                }
            } else if (index == 0 && i != 0) {
                if (ext.extensionsId == data.extensionsId) {
                    this.onError('Extension already selected');
                    this.removeExtensions(index);
                }
            }
        });

        this.extensionsList.forEach((ext) => {
            if (ext.id == data.extensionsId) {
                this.rule.extensions[index].extensionsName = ext.name;
            }
        });

        // if(data.extensionsId==null && index==0) {
        if(CommonUtils.isNil(data.extensionsId) && index==0) {
        //  this.removeExtensions(index);
             this.enableDisableButton();
        }

        // for disable plus button
        this.enableDisableButton()
    }

    enableDisableButton() {
        for (let index = 0; index < this.rule.extensions.length; index++) {
            if(this.isPremiumCalculationDisable &&  this.scopeData.policyMarketType=='OPEN'){
                this.addExtensionButtonEnable = false;
            // }else if ((this.rule.extensions[index].extensionsId) && ( this.rule.extensions[index].rate!=undefined)) {
            }else if ((this.rule.extensions[index].extensionsId) && ( !CommonUtils.isNil(this.rule.extensions[index].rate))) {
                this.addExtensionButtonEnable = false;
            } else {
                this.addExtensionButtonEnable = true;
            }
            // if the any of the fields not valid disable add button
            if (this.addExtensionButtonEnable) {
                break;
            }
        }
    }

    onSelectCargos() {
        $(document).find('.cargoClass .dropdown-list').addClass('showDropdown');
    }

    onSelectFromCountryList() {
        $(document).find('.fromCountryListClass .dropdown-list').addClass('showDropdown');
    }

    onSelectToCountryList() {
        $(document).find('.toCountryListClass .dropdown-list').addClass('showDropdown');
    }

    isSubtypeShow: any;
    onSelectLoadingTypeSelect(event,index) {
        if (event && event.id) {    
            let data = this.loadingTypesList.filter(res => res.id == event.id )
            data[0].loadingTypeAr = []
            console.log(data);
            this.rule.loadingType[ index ]=JSON.parse(JSON.stringify((data[ 0 ])));
            this.rule.loadingType[index].loadingTypeAr = [this.rule.loadingType[index]];
            this.rule.loadingType[index].isSubtypeShow = true
        }
        
    }
    onSelectLoadingTypeDeSelect(event,data,index) {
        this.rule.loadingType[index].loadingSubTypeDto[0].packingTypes.forEach(element => {
            element.ischecked = false;
        }); 
        this.rule.loadingType[index].isSubtypeShow = false
     
    }

    onDropdownLoadingTypeListClose() {
        $(document)
            .find('.loadingTypeListClass .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownFromCountryListClose() {
        $(document)
            .find('.fromCountryListClass .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownToCountryListClose() {
        $(document)
            .find('.toCountryListClass .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownCargoClose() {
        $(document)
            .find('.cargoClass .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownCloseClause2() {
        $(document)
            .find('.clauseExtension2 .dropdown-list')
            .removeClass('showDropdown');
    }

    trimDeductibleName(event, index) {
        this.rule.deductableRates[index].decuctableName = this.rule.deductableRates[index].decuctableName.trim();
    }

    trimDeductibleDescription(event, index) {
        this.rule.deductableRates[index].decuctableDescription = this.rule.deductableRates[index].decuctableDescription.trim();
    }
    trackRuleExtensionsById(index: number) {
        return index;
    }

    trackRuleLoadingTypeById(index: number) {
        return index;
    }
    trackDeductableRatesById(index: number) {
        return index;
    }

    handleEnterKeyPress(event) {
        const tagName = event.target.tagName.toLowerCase();
        if (tagName !== 'textarea') {
            return false;
        }
    }


    changeStorageDateRange(event, status) {

        if (status == 'INCEPTION') {
            this.expiryDate = null;
            // if (event != null && event.jsdate != null) {
            if (CommonUtils.isNotNil(event) && CommonUtils.isNotNil(event.jsdate)) {
                this.inceptionDateFormate = this.principal.dateFormateServerToClientMin(event.jsdate);
                this.expiryDatePickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.inceptionDateFormate,
                }
                let defMonth = event.formatted.split("/");
                this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[2] };
            }
        } else {
            // if (event != null && event.jsdate != null) {
            if (CommonUtils.isNotNil(event) && CommonUtils.isNotNil(event.jsdate)) {
                this.expiryDateFormate = this.principal.dateFormateServerToClientMax(event.jsdate);

                this.effectivepDatePickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.pastDateModel,
                    disableSince: this.expiryDateFormate,
                };

                this.fromEffeciveDate = { date: this.dateModel };
            }
        }
    }

    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        //if today date get original record
        if (this.principal.dateFormateClientToServerCDate() == selectedFromEffectiveDate) {

            this.ruleService.findForEdit(this.rule.id).subscribe(data => {
                this.rule = data.body;
                this.ruleId = this.rule.id;
                if(CommonUtils.isNotNil(this.ruleId)) {
                    this.isRuleIdPresent = true;
                }
                if (this.rule.id) {

                    this.ruleTypeValue = [];
                    if (this.rule.type == 'LOCAL') {
                        this.ruleTypeValue.push(this.ruletypeList[0]);
                        this.isRuleTypeInternational = false;
                    } else if (this.rule.type == 'INTERNATIONAL') {
                        this.ruleTypeValue.push(this.ruletypeList[1]);
                        this.isRuleTypeInternational = true;
                    }
                    this.getLoadingTypeList();
                    if (this.rule.extensions.length === 0) {
                        let extenstion = new RuleExtensionRateMySuffix();
                        this.rule.extensions.push(extenstion);
                    }
                    if (this.rule.deductableRates.length === 0) {
                        let deductableRate = new RuleDeductableRateMySuffix();
                        this.rule.deductableRates.push(deductableRate);
                    }
                } else {
                    this.rule.warStrikePremiumRate = 0;
                }
            }, err => { });
            return;
        }

        // if (this.rule.id !== null && this.rule.id !== undefined) {
        if (CommonUtils.isNotNil(this.rule.id)) {
            let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
            this.ruleService.findByIdAndFromEffectiveDate(this.rule.id, selectedFromEffectiveDate).subscribe(response => {
                // if (response.body != null && response.body['isSuccess']) {
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']) {
                    this.rule = response.body['payLoad'];
                    if (this.rule.id) {

                        if (new Date(this.rule.expiryDate).getTime() < new Date(selectedFromEffectiveDate).getTime()) {
                            this.fromEffeciveDate = { date: this.dateModel };
                        }

                        this.getLoadingTypeList();
                        if (this.rule.extensions.length === 0) {
                            let extenstion = new RuleExtensionRateMySuffix();
                            this.rule.extensions.push(extenstion);
                        }
                        if (this.rule.deductableRates.length === 0) {
                            let deductableRate = new RuleDeductableRateMySuffix();
                            this.rule.deductableRates.push(deductableRate);
                        }
                    }
                }
            });
        }
    }


    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.rule.id !== null && this.rule.id !== undefined) {
        if (CommonUtils.isNotNil(this.rule.id)) {
            let form_data = {
                masterId: this.rule.id,
                futureDataType: FutureDataType.RULE.valueOf(),
                fromEffectiveDateFormatted: this.rule.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Rule',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.rule.id,
                futureDataType: FutureDataType.RULE.valueOf(),
                fromEffectiveDateFormatted: this.rule.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                this.isConfirmDeletion = false;
            });
        }
    }

    onChangeMeanOfConveyance(event) {
        //
        //this.rule.loadingType = new LoadingTypeMySuffix();
        this.rule.loadingType = [];
        let loadingtype = new LoadingTypeMySuffix();
        this.rule.loadingType.push(loadingtype);
        this.getLoadingTypeList();

    }

    getLoadingTypeList() {
        this.loadingTypesList = [];
        this.loadingTypeMySuffixService.get('get-loading-type-list/' + this.rule.meansOfConveyance).subscribe(res => {
            this.loadingTypesList = res.body['payload'];
            console.log(this.loadingTypesList)

            this.rule.loadingType.forEach((res, index) => {
                this.rule.loadingType[index].loadingTypeAr = [];
                if (this.loadingTypesList.find(l=>l.id==res.id)) {
                    this.rule.loadingType[index].isSubtypeShow = true;
                    this.rule.loadingType[index].loadingTypeAr.push(this.rule.loadingType[index]);
                } else {
                    this.rule.loadingType[ index ].loadingSubTypeDto=null;
                    this.rule.loadingType[ index ].isSubtypeShow=false;
                }
            })
        });
    }
    onEditRuleSetLoadingTypeAndSubTypes() {

        for (let index = 0; index < this.loadingTypesList.length; index++) {
            const element = this.loadingTypesList[index];
            if (element.id == this.rule.loadingType[index].id) {

                if (this.rule.loadingType[index].isSubType) {
                    // for (let j = 0; j < this.rule.loadingSubTypes.length; j++) {
                    //     const loadingSubType = this.rule.loadingSubTypes[index];
                    // }

                    for (let _loadingSubType of this.rule.loadingSubTypes) {
                        const loadingSubType = _loadingSubType;
                    }
                }
                break;
            }
        }
    }

    onRuleTypeItemSelect(event) {
        console.log(event.id);
        if (this.rule.type) {
            this.rule.fromCountryLists = [];
            this.rule.toCountryLists = [];
        }
        if (event.id == 'LOCAL') {
            this.isRuleTypeInternational = false;
            let enumValue: any = RuleType.LOCAL;
            this.rule.type = enumValue;
            this.rule.toCountryLists = [];
        } else if (event.id == 'INTERNATIONAL') {
            this.isRuleTypeInternational = true;
            let enumValue: any = RuleType.INTERNATIONAL;
            this.rule.type = enumValue;
            this.rule.fromCountryLists = [];
            this.rule.toCountryLists = [];
        }

    }

    onRuleTypeItemDeSelect(event) {
        this.isRuleTypeInternational = true;
        this.rule.fromCountryLists = [];
        this.rule.toCountryLists = [];
    }


    isAcoountingDisable:boolean;
    isPremiumCalculationDisable:boolean;
    checkAccountingPermission(){
        this.principal.checkAccountingAccessForUser().then(res =>{
            if(res){
                console.log("checkAccountingAccessForUser if" , res);
                this.isAcoountingDisable = false;
            }else{
                console.log("checkAccountingAccessForUser else" , res);

                this.isAcoountingDisable =  true;
            }
        });
    }

    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }

    isAddSubRuleClicked: boolean = false;
    addSubRule(){
        this.isAddSubRuleClicked = true;
        localStorage.setItem('isAddSubRuleClicked', JSON.stringify(this.isAddSubRuleClicked));
        localStorage.setItem('scopeId', JSON.stringify(this.scopeData.id));
        // this.saveOrUpdate();
        // this.router.navigate(['/sub-rule-my-suffix/new/'+this.ruleId+'/'+this.scopeData.policyMarketType])
    }

    addLoadingType() {
        let loadingtype = new LoadingTypeMySuffix();
        this.rule.loadingType.push(loadingtype);
        
    }

    removeLoadingType(index: any) {
        this.rule.loadingType.splice(index, 1);
    }

    hasDuplicateObjects(arr): boolean {
        const ids: number[] = [];
        for (const obj of arr) {
            if (ids.includes(obj.id)) {
                return true;
            }
            ids.push(obj.id);
        }
        return false;
    };

    public getLadingTypeUrl():Observable<any> {
        return this.loadingTypeMySuffixService.get('get-loading-type-list/'+this.rule.meansOfConveyance);
    }


    setDataInModal(otsScopeId: any, isOts: boolean, isFromAutomateOts: boolean, certificateRequestId: string | number): OtsDataSharingModal {
        this.dataSharingModal.policyId=null;
        this.dataSharingModal.cerReqId=certificateRequestId;
        this.dataSharingModal.oldScopeId=null;
        this.dataSharingModal.oldRuleId=null;
        this.dataSharingModal.oldSubRules=[];
        this.dataSharingModal.oldSubRuleIds=[];
        this.dataSharingModal.otsScopeId=otsScopeId;
        this.dataSharingModal.otsRuleId=null;
        this.dataSharingModal.otsSubRules=[];
        this.dataSharingModal.otsSubRuleIds=[];
        this.dataSharingModal.isEdit = false;
        this.dataSharingModal.isOts = isFromAutomateOts || isOts;
        return this.dataSharingModal;
    }

    // default, unselect all box
    uncheckAllItems(items) {
        items.forEach(element => {
          element.checked = false;
          element.collapsed = false;
          if (element.internalChildren) {
            this.uncheckAllItems(element.internalChildren);
          }
        });
      }
      
      selectedFromCountries(event){
        this.selectedFromCountry = event;
        this.fromCountriesId = event;
      }

      selectedToCountries(event){
        this.selectedToCountry = event;
        this.toCountriesId = event;        
      }

      mapToTreeViewItem(data){
        for(let i = 0;i<data.length;i++){
            data[i] = new TreeviewItem(data[i]); // continent
            if(data[i].children && data[i].children.length>0){
                for(let j = 0;j<data[i].children.length;j++){
                    data[i].children[j]= new TreeviewItem(data[i].children[j]); // region
                    if(data[i].children[j] && data[i].children[j].children.length>0){
                        for(let k = 0;k<data[i].children[j].children.length;k++){
                            data[i].children[j].children[k]= new TreeviewItem(data[i].children[j].children[k]); // country
                            this.countriesMap.set(data[i].children[j].children[k].value,data[i].children[j].children[k]);
                        }
                    }
                }
            }
        }
        return data;
      }

      onFilterChange(event){
        console.log("", event);
      }

      onFilterFromCountry(e: any, fromCountryList: NgModel) {
        const filterValue = (e.target as HTMLInputElement).value;
        if(filterValue.length === 0) {
            fromCountryList.control.setErrors(null);
        }
      }

      onFilterToCountry(e: any, toCountryList: NgModel) {
        const filterValue = (e.target as HTMLInputElement).value;
        if(filterValue.length === 0) {
            toCountryList.control.setErrors(null);
        }
      }
}
